import { CSSProperties } from 'react';
import { ControlPosition } from 'react-draggable';
import { TBarPosition } from 'src/types/mixed.type';

export type DraggableModalPropsType = {
  id?: string;
  children: React.ReactNode;
  className?: string;
  contentClassName?: string;
  headerText: string;
  onClickClose: () => void;
  position?: {
    x: number;
    y: number;
  };
  isHeaderOn?: boolean;
  onStop?: (pos: TBarPosition) => void;
  extraContent?: JSX.Element;
  style?: CSSProperties;
  defaultPosition?: ControlPosition;
  isDrawModal?: boolean;
  isResizable?: boolean;
  enableFullscreen?: boolean;
};

export const defaultDraggableModalPropsForMapComponent = {
  style: {
    width: '81vw',
    height: '80vh',
    minWidth: '240px',
    minHeight: '200px',
    maxWidth: '99.9vw',
    maxHeight: '94vh',
  },
  isResizable: true,
  enableFullscreen: true,
};
